import { render } from "./AppPaletteDeterminantSettingsModal.vue?vue&type=template&id=cf92defa&scoped=true&ts=true"
import script from "./AppPaletteDeterminantSettingsModal.vue?vue&type=script&lang=ts"
export * from "./AppPaletteDeterminantSettingsModal.vue?vue&type=script&lang=ts"

import "./AppPaletteDeterminantSettingsModal.vue?vue&type=style&index=0&id=cf92defa&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf92defa"]])

export default __exports__